import React from "react";

function History() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/temple.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div class="container">
        <div class="row">
          <div class="history">
            <div style={{ width: '100%', padding: '50px', boxShadow: '0px 0px 15px silver' }}>
              <img src="./images/god.png" alt="" style={{ width: '100%' }} />
              <h3 className="hheading" style={{ marginTop: '50px' }}>Temple History</h3>
              <p className="hcontent">
                One of the most famous Lord Subramanya temples in Kerala, Sree Subramanya Swami Temple at Payyanur in Kannur district of Kerala has specific architectural significance. The two-storeyed sanctum sanctorum here is in the shape of Gajaprishtam [back of an elephant]. This temple also has a 6-ft tall idol of the main deity, Lord Subramanya. Another interesting feature is its 12ft tall compound wall that is constructed in a unique style. <br />
                The temple is famous for its pavitra mothiram, a uniquely crafted ring. Made only against the order, with gold and the holy darbha grass, it is worn after being sanctified at the temple.
              </p>


            </div>

          </div>

        </div>


      </div>
    </div>
  );
}

export default History;
